import React from 'react';

const About = () => (
  <section id="about" className="section is-medium">
    <div className="container">
      <div className="has-text-centered mb-6">
        <h2 className="title is-2 has-text-primary">About AZCOREMSH.NET</h2>
        <div className="subtitle is-5 has-text-grey">
          Connecting Arizona through decentralized mesh technology
        </div>
      </div>
      
      <div className="columns is-centered">
        <div className="column is-8">
          <div className="content is-medium has-text-centered">
            <p className="is-size-5">
              AZCOREMSH.NET is a community-driven mesh networking project based in Arizona. Our goal is to build a resilient, decentralized communication network using MeshCore and LoRa-based hardware.
            </p>
            <p className="is-size-5">
              Whether you're in a city or off-grid, AZCOREMSH empowers individuals to stay connected without relying on traditional internet or cellular infrastructure.
            </p>
          </div>
        </div>
      </div>
      
      <div className="columns is-variable is-6 mt-6 is-multiline">
        <div className="column is-one-third-desktop">
          <div className="box has-text-centered is-flex is-flex-direction-column is-fullheight">
            <div className="mb-4">
              <span className="icon is-large has-text-primary">
                <i className="fas fa-users fa-3x"></i>
              </span>
            </div>
            <h3 className="title is-4 has-text-primary">Community-Driven</h3>
            <p className="is-size-6">Built by and for the people of Arizona, fostering local connections and collaboration</p>
          </div>
        </div>
        <div className="column is-one-third-desktop">
          <div className="box has-text-centered is-flex is-flex-direction-column is-fullheight">
            <div className="mb-4">
              <span className="icon is-large has-text-primary">
                <i className="fas fa-network-wired fa-3x"></i>
              </span>
            </div>
            <h3 className="title is-4 has-text-primary">Decentralized</h3>
            <p className="is-size-6">Resilient network independent of traditional infrastructure, ensuring reliability</p>
          </div>
        </div>
        <div className="column is-one-third-desktop">
          <div className="box has-text-centered is-flex is-flex-direction-column is-fullheight">
            <div className="mb-4">
              <span className="icon is-large has-text-primary">
                <i className="fas fa-code-branch fa-3x"></i>
              </span>
            </div>
            <h3 className="title is-4 has-text-primary">Open Source</h3>
            <p className="is-size-6">Supporting experimentation and collaborative learning through open development</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default About;
